import { ILoader } from '../types/loader';
import { SET_LOADER } from './types';

export function setLoaderAction(payload: ILoader) {
  return {
    type: SET_LOADER,
    payload,
  };
}
